import { Component, Input } from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'

@Component({
   selector: 'app-loader',
   standalone: true,
   imports: [TranslocoDirective],
   templateUrl: './loader.component.html',
   styles: ''
})
export class LoaderComponent {
   @Input() loading!: boolean
   @Input() message!: string
   @Input() height!: string

}
